import React from "react";
import { Button, Form, Input } from "antd";
import { useNavigate } from "react-router";
import { useAuth } from "../../context/AuthContext";
import { useLocation } from "react-router";
import { Severty, ShowToast } from "../../helper/toast";

const ResetPassword = () => {
  // ---------- constants ----------
  const [form] = Form.useForm();
  const { resetPassword } = useAuth();
  const Navigate = useNavigate();
  const location = useLocation();
  const { data } = location.state || {};

  // ----------- handlers -------------
  const handleFinish = async (values) => {
    try {
      let resetData = {
        ...data,
        password: values.newPassword,
      };
      const response = await resetPassword(resetData);
      if (response.status === 200) {
        Navigate("/sign-in");
      }
    } catch (error) {
      ShowToast(error.message, Severty.ERROR);
    }
  };

  return (
    <div className="signup-container">
      <div className="signup-box">
        <h4 className="signup-title">Reset Password</h4>
        <p className="signup-subtitle">
          Enter the OTP code we just sent you on your registered Email/Phone
          number
        </p>

        <Form
          form={form}
          layout="vertical"
          onFinish={handleFinish}
          requiredMark={false}
        >
          <Form.Item
            name="newPassword"
            rules={[
              { required: true, message: "Please enter your new password" },
              { min: 6, message: "Password must be at least 6 characters" },
              {
                validator: (_, value) => {
                  if (!value || value.trim() === "") {
                    return Promise.reject(
                      new Error("Password cannot be empty or just spaces")
                    );
                  }

                  // strong password regex
                  const strongPasswordRegex =
                    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&#^])[A-Za-z\d@$!%*?&#^]{6,}$/;

                  if (!strongPasswordRegex.test(value)) {
                    return Promise.reject(
                      new Error(
                        "Password must include uppercase, lowercase, number, and special character"
                      )
                    );
                  }

                  return Promise.resolve();
                },
              },
            ]}
          >
            <Input.Password
              className="signup-input"
              placeholder="New Password"
            />
          </Form.Item>

          <Form.Item
            name="confirmPassword"
            dependencies={["newPassword"]}
            rules={[
              { required: true, message: "Please confirm your password" },
              ({ getFieldValue }) => ({
                validator(_, value) {
                  if (!value || getFieldValue("newPassword") === value) {
                    return Promise.resolve();
                  }
                  return Promise.reject(new Error("Passwords do not match"));
                },
              }),
            ]}
          >
            <Input.Password
              className="signup-input"
              placeholder="Confirm Password"
            />
          </Form.Item>

          <Form.Item>
            <Button htmlType="submit" className="Fill-button">
              Save Password
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
  );
};

export default ResetPassword;
